export default {
  purpleGradient: {
    bgGradient: 'linear(to-b, rgba(255, 255, 255, .41), #F7F2FF)',
  },
  blueGradient: {
    bgGradient: 'linear(to-b, rgba(255, 255, 255, .41), #F7F7FF)',
  },
};
